import { useState } from "react"

// global imports
import { companyStore } from "../../store/Store"

// hooks
import useGetFetch from "../../hooks/useGetFetch"
import Loading from "../../components/Loading"
import ErrorDisplay from "../../components/ErrorDisplay"

// css and images
import DisplayList from "../../components/DisplayList"
import { Outlet, useParams } from "react-router-dom"


export default function CompanyCarriers() {
  // global
  const companyCarriers = companyStore(data => data.companyCarriers)
  const setCompanyCarriers = companyStore(data => data.setCompanyCarriers)

  // local
  const [trigger, setTrigger] = useState(false)
  const {id} = useParams()

  // get all company carriers
  const {isPending, error} = useGetFetch(`${process.env.REACT_APP_BACKEND}/pc/company-carriers`, setCompanyCarriers)
  
  if (isPending) {
    return (<Loading />)
  }
  if (error) {
    return (<ErrorDisplay message={"Something Went Wrong"} code={500} />)
  }
  
  return (
    <div className="container-fluid">
      {!id && <DisplayList 
        coll={"Company Carriers"}
        docs={companyCarriers}
        err={error}
        trigger={trigger}
        setTrigger={setTrigger}
        url={`${process.env.REACT_APP_BACKEND}/pc/company-carriers`}
        setState={setCompanyCarriers}
        statusToggle={true}
        isNavigation={true}
      />}
      <Outlet />
    </div>
  )
}